import React, { lazy, Suspense, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Landing } from './landing';
import './tokens.css';
import './styles.css';
import './landing.css';
import { initTheme } from './theme';

// 错误监控：VITE_SENTRY_DSN 未配置时不启用（开发/测试默认关闭，生产构建时注入）
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
}

// 渲染前初始化主题（从 localStorage 读取并应用到 documentElement），避免首屏闪烁
initTheme();

const Workspace = lazy(() => import('./workspace'));

function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title =
      pathname === '/'
        ? '追焦 ZHUIJIAO · 不经意的瞬间，值得好好珍藏'
        : pathname.startsWith('/admin')
          ? '追焦 · 平台管理'
          : '追焦 · 创作者工作台';
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="*"
        element={
          <Suspense
            fallback={
              <div className="boot" role="status">
                正在打开工作台…
              </div>
            }
          >
            <Workspace />
          </Suspense>
        }
      />
    </Routes>
  );
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/upload-offline-sw.js').catch(() => {});
  });
}
